import { render, staticRenderFns } from "./spareRequirementsAdd.vue?vue&type=template&id=08d7ab0b&scoped=true"
import script from "./spareRequirementsAdd.vue?vue&type=script&lang=js"
export * from "./spareRequirementsAdd.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsAdd.vue?vue&type=style&index=0&id=08d7ab0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7ab0b",
  null
  
)

export default component.exports